import React, { useCallback, useMemo, useRef, useState } from "react";
import "./Register.css";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useAuth } from "../../../hooks/useAuth";
import { saveUser, updateUser, saveFile } from "../../../services/UsersService";
import { roles } from "../../../constants/roles";
import { ToastContainer, toast } from "react-toastify";
import Loading from "../../../components/loading/Loading";
import { Selector } from "../../../components/selector/Selector";
import { PrimaryButton } from "../../../components/primary/PrimaryButton";
import { initializeRoles } from "./RegisterList";

const countryCodes = [
  { value: "+1", label: "America" },
  { value: "+52", label: "México" },
];

const selectStyles = {
  control: {
    border: "none",
    borderRadius: "12px",
    boxShadow: "none",
    "&:hover": {
      border: "none",
    },
  },
};

const removeRoles = (role) => {
  if (role === roles.CLIENT) {
    return [];
  }

  if (role === roles.ADMIN) {
    return initializeRoles.filter((r) => r.value !== roles.ADMIN);
  }

  if (role === roles.COORDINATOR) {
    return initializeRoles.filter(
      (r) => ![roles.ADMIN, roles.COORDINATOR].includes(r.value)
    );
  }

  if (role === roles.ORGANIZATION) {
    return initializeRoles.filter(
      (r) =>
        ![roles.ADMIN, roles.ORGANIZATION, roles.COORDINATOR].includes(r.value)
    );
  }
  if (role === roles.SELLER) {
    return initializeRoles.filter(
      (r) =>
        ![
          roles.ADMIN,
          roles.ORGANIZATION,
          roles.COORDINATOR,
          roles.SELLER,
        ].includes(r.value)
    );
  }

  return initializeRoles;
};

const data = {
  clients: [
    {
      id: 18,
      name: "andres",
      last_name: "coordinador",
      country_code: "+52",
      phone: "3118428831",
      email: "andrescorrdinador@email.com",
    },
  ],
  coordinators: [],
  organizations: [
    {
      id: 4,
      name: "organizacion",
      last_name: "uno",
      country_code: "+52",
      phone: "3118428835",
      email: "organizacion1@email.com",
    },
  ],
  sellers: [
    {
      id: 7,
      name: "vendedor",
      last_name: "uno",
      country_code: "+52",
      phone: "3118428833",
      email: "vendedor1@email.com",
    },
  ],
};

const Table = ({ title, data }) => (
  <div className="my-8">
    <h2 className="text-lg font-semibold mb-4">{title}</h2>
    <table className="w-full  table-auto rounded-lg shadow-lg">
      <thead className="text-black bg-header">
        <tr>
          <th className="text-left px-4 py-2">Usuario</th>
          <th className="text-left px-4 py-2">Nombre</th>
          <th className="text-left px-4 py-2">Apellido</th>
          <th className="text-left px-4 py-2">Teléfono</th>
          <th className="text-left px-4 py-2">Email</th>
        </tr>
      </thead>
      <tbody>
        {data.map((persona, index) => (
          <tr
            className={`border-b border-white text-sm ${
              index % 2 === 0 ? "bg-white" : "bg-header"
            }`}
            key={persona.id}
          >
            <td className="px-4 py-2 text-primary">{persona.id}</td>
            <td className="px-4 py-2 text-black-50">{persona.name}</td>
            <td className="px-4 py-2 text-black-50">{persona.last_name}</td>
            <td className="px-4 py-2 text-black-50">{persona.phone}</td>
            <td className="px-4 py-2 text-black-50">{persona.email}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default function TableUsers({
  userToEdit,
  onSuccess,
  type = "",
  setType,
  users
}) {
  const roles = [
    { title: "Coordinadores", data: users?.coordinators },
    { title: "Organizaciones", data: users?.organizations },
    { title: "Vendedores", data: users?.sellers },
    { title: "Clientes", data: users?.clients },
  ];

  if (!users?.organizations?.length && !users?.sellers?.length  && !users?.clients?.length > 0) {
    return (
      <div className="flex justify-center Register mt-10">
        <p>No hay roles asignados</p>
      </div>
    )
  }

  return (
    <div className="flex justify-center Register">
      <div className="w-full px-5 lg:px-8 mt-1 bg-white rounded-md text-dark">
        {roles
          .filter((role) => role.data.length > 0) // Filtrar roles vacíos
          .map((role) => (
            <Table key={role.title} title={role.title} data={role.data} />
          ))}
      </div>
    </div>
  );
}
